import { useEffect } from "react"

import { useForm, useStepTransition } from "@garantidos/hooks"
import { httpRequests, proposalHttpController } from "@garantidos/services"
import { setItem } from "@garantidos/utils"

import isMobile from "@mobi/utils/browser/isMobile"

import validatorsDictionary from "pages/Proposal/hooks/validators"

import useSoftleadOneClick from "../../hooks"

import { ProposalContext, useProposalContext } from "contexts/proposal"

import { fields } from "../../fields"
import * as trackers from "../../trackings"

const useCpf = () => {
  const { hashDocument } = httpRequests
  const { setTrackingBackHome } = useSoftleadOneClick()

  const { form } = useForm({
    fields,
    context: ProposalContext,
    validatorsDictionary
  })

  const {
    cpfData,
    errorMessage,
    setErrorMessage,
    isLoading,
    setIsLoading,
    updateCpfData,
    sendProposalData,
    setIsStepVisible,
    updateStepInfo
  } = useProposalContext()

  const { stepNavigator } = useStepTransition(setIsStepVisible)
  const { hashedCpf } = cpfData

  useEffect(() => {
    if (!hashedCpf) {
      trackers.simulationStarted()
    }
    trackers.pageview("", "cpf")
    setTrackingBackHome("cpf")
  }, [])

  const onSubmitCallback = async (formData) => {
    try {
      if (isLoading) return
      setIsLoading(true)

      const { proponent_document } = formData
      const cpfWithoutFormatting = proponent_document.replace(/[^0-9,]*/g, "")

      let hashedCpf = await hashDocument(cpfWithoutFormatting)
      updateCpfData({ cpf: cpfWithoutFormatting, hashedCpf })

      const payload = {
        proponent_document: cpfWithoutFormatting,
        mobile: isMobile
      }
      const response = await sendProposalData({
        payload,
        method: "post",
        flow: "default",
        step: "init-softlead-simulation",
        clearStepNaviagation: false
      })
      const nextStep = response.stepNavigation.currentStep
      const next =
        nextStep == "softlead" ? "softlead-simulation-name" : nextStep
      if (next === "softlead-simulation-name") {
        updateStepInfo({
          current_step: next,
          previous_step: "softlead-simulation-cpf",
          next_step: next
        })
      }
      stepNavigator("next", next)
      setIsLoading(false)
      setItem("cpfFromHero", cpfWithoutFormatting)
      setItem("eq3_uuid", response?.stepData?.eq3_uuid)
      trackers.advance(hashedCpf, "cpf")
    } catch (error) {
      console.error(error)
      setIsLoading(false)
      setErrorMessage(error?.message)
    }
  }

  return {
    onSubmitCallback,
    fields,
    form,
    errorMessage,
    setErrorMessage,
    isLoading
  }
}

export default useCpf
